<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'VFatherProAnamANxAL',
  components: {},
};
</script>
